import * as types from '../mutationTypes'
const state = {
  // 选择寄地址省市区的数据
  sendDetail: {
    sendInfo: {
      country: '', // 国家
      countryUnit: '', // 国家 code
      cnCountry: '', // 国家 中文
      userProvince: '',
      userCity: '',
      userArea: '',
      userProvinceCode: '',
      userCityCode: '',
      userAreaCode: '',
      postCode: '', // 邮编
      location: { lng: '', lat: '' }
    },
    sendAddressDetail: ''
  },
  receDetail: {
    // 选择收地址省市区的数据
    receInfo: {
      country: '', // 国家
      countryUnit: '', // 国家 code
      cnCountry: '', // 国家 中文
      userProvince: '',
      userCity: '',
      userArea: '',
      userProvinceCode: '',
      userCityCode: '',
      userAreaCode: '',
      postCode: '', // 邮编
      location: { lng: '', lat: '' }
    },
    receAddressDetail: ''
  },
  weight: '',
  addressTree: [] // 国内省市区地址树
}

const mutations = {
  [types.SET_RECE_DETAIL] (state, data) {
    state.receDetail = data
  },
  [types.SET_SEND_DETAIL] (state, data) {
    state.sendDetail = data
  },
  [types.SET_WEIGHT] (state, data) {
    state.weight = data
  },
  [types.SET_ADDRESS_TREE] (state, data) {
    state.addressTree = data
  }
}

const actions = {
  // 设置收件数据
  setReceDetail ({ commit }, data) {
    commit(types.SET_RECE_DETAIL, data)
  },
  // 设置寄件数据
  setSendDetail ({ commit }, data) {
    commit(types.SET_SEND_DETAIL, data)
  },
  // 设置重量
  setWeight ({ commit }, data) {
    commit(types.SET_WEIGHT, data)
  },
  // 设置省市区文件
  setAddressTree ({ commit }, data) {
    commit(types.SET_ADDRESS_TREE, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
